import { render, staticRenderFns } from "./SystemSettingsSMSProvider.vue?vue&type=template&id=01c85440&scoped=true"
import script from "./SystemSettingsSMSProvider.vue?vue&type=script&lang=js"
export * from "./SystemSettingsSMSProvider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c85440",
  null
  
)

export default component.exports